import { useEffect, useState } from "react"
import { InitialPallets } from "../../interfaces/intakes.reports"
import Badge from "./Badge"
import { ModalPalletRefName } from "./ModalPalletRefName"

interface Props {
    pallet: InitialPallets
    reportId: string
}
export const PalletReferenceName = ({ pallet, reportId }: Props) => {

    const [pallerRef, setPallerRef] = useState<string | undefined>(undefined)
    const [openPalletRef, setOpenPalletRef] = useState<boolean>(false)

    useEffect(() => {
        const existPalletRef = pallet.labels.data.find(item => item.name === "pallet_reference")
        if (existPalletRef) {
            setPallerRef(existPalletRef.value as string)
        }
    }, [pallet])

    const openEditPalletRef = () => {
        if (pallerRef !== undefined) {
            setOpenPalletRef(true)
        }
    };

    return (
        <div>

            {
                (openPalletRef && pallerRef !== undefined) &&
                <ModalPalletRefName
                    closeModal={() => setOpenPalletRef(false)}
                    reportId={reportId}
                    palletId={pallet.pid}
                    detailName="labels"
                    item={pallet.labels.data.find(item => item.name === "pallet_reference")!}
                />
            }

            {/* {pallerRef
                ? <Badge color="outline" >
                    {pallerRef}
                </Badge>
                : <Badge color="grey" className="border">
                    <button className="font-small" onClick={openEditPalletRef}>Add Pallet Name</button>
                </Badge>
            } */}

            <Badge color={pallerRef ? "outline" : "grey"} >
                <button className="font-small" onClick={openEditPalletRef}>{pallerRef ? pallerRef : "Add Pallet Name"}</button>
            </Badge>

        </div>
    )
}
